const NOTIFICATION_INFO = 'NOTIFICATION_INFO';
export const sendNotification = (payload) => {
    return dispatch => {
        dispatch({
            type: NOTIFICATION_INFO,
            payload: payload
        });
    };
};
